import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-right-circle-semifilled-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "currentColor" },
        React.createElement("circle", { cx: 8.5, cy: 8.5, r: 7.5, fillRule: "evenodd", opacity: 0.1 }),
        React.createElement("path", { d: "M9 6.5a.5.5 0 0 1 .854-.354l2 2a.5.5 0 0 1 0 .708l-2 2A.5.5 0 0 1 9 10.5V9H5.5a.5.5 0 0 1 0-1H9Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
